import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import Exploitation from "@/components/Exploitation";
import Produits from "@/components/Produits";
import Engagements from "@/components/Engagements";
import Visites from "@/components/Visites";
import BrelesBalades from "@/components/BrelesBalades";
import OuNousTrouver from "@/components/OuNousTrouver";
import Evenements from "@/components/Evenements";
import Presse from "@/components/Presse";
import Tourisme from "@/components/Tourisme";
import Avis from "@/components/Avis";
import FAQ from "@/components/FAQ";
import Contact from "@/components/Contact";
import Newsletter from "@/components/Newsletter";
import OrderBanner from "@/components/OrderBanner";
import ConceptCommande from "@/components/ConceptCommande";
import Footer from "@/components/Footer";
import FloatingCall from "@/components/FloatingCall";
import Admin from "@/pages/Admin";
import Commande from "@/pages/Commande";

const Home = () => {
  return (
    <div className="App bg-sable overflow-x-hidden">
      <Navbar />
      <main>
        <Hero />
        <ConceptCommande />
        <Exploitation />
        <Produits />
        <Engagements />
        <Visites />
        <BrelesBalades />
        <OuNousTrouver />
        <Evenements />
        <Presse />
        <Tourisme />
        <Avis />
        <FAQ />
        <OrderBanner />
        <Contact />
        <Newsletter />
      </main>
      <img
        src="https://customer-assets.emergentagent.com/job_bourgogne-escargots/artifacts/6yyesapz_photo%20avec%20logo.jpg"
        alt="Escarg'Holala — Savourez Savianges"
        data-testid="bottom-banner"
        className="w-full h-auto block"
      />
      <Footer />
      <FloatingCall />
    </div>
  );
};

function App() {
  return (
    <BrowserRouter>
      <Toaster position="top-right" richColors />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/commander" element={<Commande />} />
        <Route path="/admin" element={<Admin />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
